import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Tingimused from './views/Tingimused'
import PaymentSuccess from './views/payments/PaymentSuccess'
import PaymentFailure from './views/payments/PaymentFailure'
import Privaatsuspoliitika from './views/Privaatsuspoliitika'
import Login from './views/account/Login'
import Register from './views/account/Register'
import Calendar from './views/calendar/Calendar'
import Reservations from './views/account/Reservations'
import Settings from './views/account/Settings'
import SetPassword from './views/account/SetPassword'
import ForgotPassword from './views/account/ForgotPassword'
import PageNotFound from './views/404'
import store from './store';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'calendar',
      component: Calendar,
      meta: {title: 'Calendar'}
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      meta: {title: 'Calendar'}
    },
    {
      path: '/reservations',
      name: 'reservations',
      component: Reservations,
      meta: {title: 'Reservations', requiresAuth: true}
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {title: 'Settings', requiresAuth: true}
    },
    {
      path: '/success',
      name: 'paymentsuccess',
      component: PaymentSuccess,
      meta: {title: 'Order paid'}
    },
    {
      path: '/failure',
      name: 'failure',
      component: PaymentFailure,
      meta: {title: 'Order not paid'}
    },
    {
      path: '/setpassword',
      name: 'setpassword',
      component: SetPassword,
      meta: {title: 'Set password'}
    },
    {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: ForgotPassword,
      meta: {title: 'Forgot password'}
    },
    {
      path: '/tingimused',
      name: 'tingimused',
      component: Tingimused,
      meta: {title: 'Üld- ja ostutingimused'}
    },
    {
      path: '/privaatsuspoliitika',
      name: 'privaatsuspoliitika',
      component: Privaatsuspoliitika,
      meta: {title: 'Privaatsuspoliitika'}
    },
    {
      path: "*",
      component: PageNotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js